import styled, {css} from 'styled-components'
import media from '../../styles/MediaQueries'
import { LightGrey1, defaultBoxShadow, textSizePar, subtitleSizeBig } from '../../styles/SharedStyles'

const borderRadius = `3px;`

export const MainContainer = styled.div`

    display: grid;

    &:not(:last-of-type){
        border-bottom: 1px solid rgba(0, 0, 0, .25);
    }

    ${media.largest`
        width: calc(100% - 2*15rem);
        padding: 20rem 3rem;
        grid-gap: 4.5rem;
   `}   

    ${media.large`
        width: calc(100% - 2*10rem);
        padding: 20rem 2.5rem;
        grid-gap: 3.5rem;
   `}   

   ${media.medium`
        width: calc(100% - 2*6rem);
        padding: 10rem 1rem;
        grid-gap: 1rem;
   `}   

   ${media.small`
        width: calc(100% - 2*7.5rem);
        padding: 10rem 2.5rem;
        grid-gap: 1rem;
        grid-template-columns: 1fr;

        grid-template-areas:"title"
                            "summary" 
                            "logo"
                            "image"
                            "libs"
                            "charts"
                            "sources"
   `}   

   ${media.smallest`
        width: calc(100% - 2*6rem);
        padding: 9rem 2.5rem;
        grid-gap: .5rem;
   `}  

    ${media.tiny`
        width: calc(100% - 2*5rem);
        padding: 8rem 2rem;
        grid-gap: .1rem;
   `}    

    width: calc(100% - 2*20rem);
    padding: 25rem 5rem;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 5rem;
   
    ${props => props.position === 'right' ? css`
        grid-template-areas: "logo title"
                            "logo summary"
                            "image image"
                            "libs charts"
                            ". sources"
    ` : css`
        grid-template-areas: "title logo"
                            "summary logo"
                            "image image"
                            "charts libs"
                            "sources ."
    `}

}
`

export const ElementContainer = styled.div`
    
    display: flex;
    flex-direction: ${props => props.direction || 'row'};
    justify-content: ${props => props.justify || 'center'};;
    align-items: ${props => props.align || 'center'};
    grid-area: ${props => props.area};

    ${media.medium`
        padding: ${props => props.noPadding ? 0 : 2}rem;
    `}

    ${media.smallest`
        padding: ${props => props.noPadding ? 0 : 1.5}rem;
    `}

    ${media.tiny`
        padding: ${props => props.noPadding ? 0 : 1.25}rem;
        flex-direction: column;
        align-items: flex-start;
   `}    

    padding: ${props => props.noPadding ? 0 : 2.5}rem;


    .logo {

        ${media.medium`
            height: ${props => props.logoSizer * 14}rem;
        `}

        ${media.small`
            height: ${props => props.logoSizer * 12}rem;
        `}

        ${media.smallest`
            height: ${props => props.logoSizer * 10}rem;
        `}

        ${media.tiny`
            height: ${props => props.logoSizer * 8}rem;
        `}  

        height:  ${props => props.logoSizer * 16}rem;

    }

    
    .image-container {
        box-shadow: ${defaultBoxShadow};
        position: relative;
        border-radius: ${borderRadius};
        overflow: hidden;

        .link-button {

            ${media.medium`
                padding: .5rem .9rem .6rem .9em;
                display: inline-block;
                bottom: .75rem;
                right: .75rem;
            `}

            ${media.smallest`
                padding: .3rem .75rem .4rem .75em;
                bottom: .5rem;
                right: .5rem;
            `}

            background: #000;
            padding: .6rem 1rem .8rem 1rem;
            text-align: center;
            letter-spacing: .1rem;
            font-weight: 400;
            border-radius: ${borderRadius};
            color: #fff;
            font-size: ${textSizePar};
            text-decoration: none;
            z-index: 20;

            position: absolute;
            bottom: 1rem;
            right: 1rem;
            display: none;
            transiton: all .5s;


            &:hover {
                display: inline-block;
            }

        }

        .image-overlay {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 10;
            background-color: #000;
            opacity: 0;
            transition: opacity .5s;

            &:hover + .link-button {
                display: inline-block;
            }
        }

        .image {
            width: 100%;
        }
    }


    h1 {
        font-size: 6.4rem;
        font-weight: 200;
        line-height: 1;
    }


    h4 {

        ${media.medium`
            line-height: 2.5;
        `}

        ${media.smallest`
            line-height: ${props => props.lineHeight || 1.5};
        `}
        
        color: ${LightGrey1};
        font-size: ${subtitleSizeBig};
        font-weight: 200;
        line-height: 3;
    }

    p {
        font-size: ${textSizePar};
        font-weight: 300;
        line-height: 2;
    }

    
`